import React from 'react';

const Healing = () => {
  return (
    <>
      {/* Founders Section */}
      <section id="founders" className="py-32 bg-gray-50">
        <div className="max-w-6xl mx-auto px-6">
          <h2 className="text-3xl font-light text-center tracking-wide mb-4">ABOUT FOUNDERS OF BOTSWALLE</h2>
          <div className="section-divider"></div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-16 mt-16">
            <div className="flex flex-col justify-center" data-aos="fade-right">
              <p className="text-gray-700 mb-6 leading-relaxed">
                Khosikhadi Mmatlala Mudau and Kgosi Tshabalala begin this journey of Botswalle as a contribution to the healing space, 
                as trained African traditional practitioners. A journey that aligned with the path of their forefathers, of connecting 
                to who we are as Batho/Bantu which is healing occurs in shared experiences.
              </p>
              
              <p className="text-gray-700 mb-6 leading-relaxed">
                The journey of Botswalle, is to build relations stemming from the connection of self, to connecting with others. 
                In this way, our aim is to share and explore healing journey's with others, that like us are looking to reflect 
                humanity, love, kindness and intentional living.
              </p>
              
              <p className="text-gray-700 mb-6 leading-relaxed">
                Through the Organization we are looking to connect with different healers in the practice of serving the well-being 
                of people, From specialist of all kinds, it be psychologist, psychiatrists, social workers, indigenous traditional 
                healers, scholars, doctors and elders of different indigenous knowledge system.
              </p>
              
              <p className="text-gray-700 leading-relaxed">
                In so doing, we aim to address and re-address the conversations around mental health and healing in our community 
                spaces and our people.
              </p>
            </div>
            <div data-aos="fade-left">
              <img 
                src="/images/image00009.jpeg" 
                alt="The founders of Botswalle" 
                className="w-full object-cover h-full"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Healing Section */}
      <section id="healing" className="py-32 bg-white">
        <div className="max-w-6xl mx-auto px-6">
          <h2 className="text-3xl font-light text-center tracking-wide mb-4">ABOUT MY HEALING</h2>
          <div className="section-divider"></div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-16 mt-16">
            <div className="flex flex-col justify-center" data-aos="fade-right">
              <h3 className="text-xl font-light mb-6 tracking-wide">KHOSIKHADI MMATLALA WA MUDAU</h3>
              <p className="text-gray-700 mb-6 leading-relaxed">
                Mmatlala in its meaning is "mother of hunger" the one sent to feed the nation. She is from the royal mountains 
                of Malematja wa Lethwane under the queens rulership Khosikhadi Modjadji wa Bolobedu, in Limpopo.
              </p>
              
              <div className="bg-gray-50 p-6 mb-6 italic">
                <p>Ke Malematja!<br/>
                Ka tswala ka folotja ka boela bophapalene bja dipudi,<br/>
                Ke motswapo monakha khelemo lehlabula o nya ka mafure,<br/>
                Ke khehloholo kha khetho pudi tja bokhalaka khe kheile go buna mabele khare batho a le nrone, khare okwa lekhwekhwe khare batho myayene,<br/>
                Ke mohlogolo wa bommapolo kheripa kheripela nnyo mpopone,<br/>
                Ke maana go buswa madumela go retwa!</p>
              </div>
              
              <div className="bg-gray-50 p-6 mb-6 italic">
                <p>She is granddaughter to the royal Mashao!<br/>
                Ndi Mashao mofamade ntomba ya nkwezi zansinda ndia shodludla ndi kodlobe ya shango.agee kolobe!</p>
              </div>
              
              <p className="text-gray-700 mb-6 leading-relaxed">
                Mmatlala embarks on her healing journey in 2022 highly cultivated in connecting with the root of self. 
                From both her maternal and paternal side, her journey comprises of healing the identity of who she is and her purpose in life.
              </p>
              
              <p className="text-gray-700 mb-6 leading-relaxed">
                Khosikhadi Mmatlala wa Mudau Malematja Mashao, is qualified as ngaka chupa and mosebeletse/morapedi (a prayer worrier).
              </p>
              
              <p className="text-gray-700 mb-6 leading-relaxed">
                Her believe is that she is "healing to heal" and because of that she pours from a cup that is filled. 
                Her firm believe is that you cannot give what you don't have, thus is her practice in healing.
              </p>
              
              <p className="text-gray-700 leading-relaxed">
                Botswalle forms a platform that she can exercise what she has been called to do by her people as a leader and healer.
              </p>
            </div>
            <div data-aos="fade-left">
              <img 
                src="/images/image00011.jpeg" 
                alt="Khosikhadi Mmatlala wa Mudau in traditional healing attire" 
                className="w-full object-cover h-full"
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Healing;